import * as React from 'react'
import { ISettingItem } from '../../types'

interface ISettingRemoveContentProps {
  setting: ISettingItem
  settingType: string
  onClose: () => void
  onRemove: () => void
}

const SettingRemoveContent = (props: ISettingRemoveContentProps) => (
  <>
    <div className='h5 center'>Are you sure you want to remove</div>
    <div className='h4 bold center'>{props.setting.label}</div>
    <div className='h5 center'>from {props.settingType} ?</div>
    <div className='right-align mt1'>
      <button className='p1 font-grey h5 bg-white border-white mr1' onClick={props.onClose}>
        Cancel
      </button>
      <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-orange border-orange font-white' onClick={props.onRemove}>
        Remove
      </button>
    </div>
  </>
)

export default SettingRemoveContent



// WEBPACK FOOTER //
// ./src/components/global-settings/SettingRemoveContent.tsx